@use '@/styles/tokens' as *;

.notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-6);
  border: 0.5px solid var(--overlay-10);
  border-radius: 10px;
  background: var(--surface-card);
}

.noticeText {
  margin: 0;
  font-size: $font-size-sm;
  color: var(--text-muted);
}
